import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { educationApi } from 'apis/educations.apis';
import { EducationPayload, UpdateEducationPayload } from 'interfaces/educations.interfaces';
import { QueryParams } from 'interfaces/query.interfaces';
import { showServerError } from 'utils/modules.utils';
import { intl } from 'utils/translation.utils';

export const EDUCATIONS_SLICE_NAME = 'educations';

export const asyncGetEducations = createAsyncThunk(
  `${EDUCATIONS_SLICE_NAME}/getEducations`,
  async (query: QueryParams, { rejectWithValue }) => {
    try {
      const response = await educationApi.getEducations(query);
      return response.data;
    } catch (e) {
      showServerError(e);
      return rejectWithValue(e);
    }
  },
);

export const asyncGetEducation = createAsyncThunk(
  `${EDUCATIONS_SLICE_NAME}/getEducation`,
  async (payload: string, { rejectWithValue }) => {
    try {
      const response = await educationApi.getEducation(payload);
      return response.data.data;
    } catch (e) {
      showServerError(e);
      return rejectWithValue(e);
    }
  },
);

export const asyncUpdateEducation = createAsyncThunk(
  `${EDUCATIONS_SLICE_NAME}/updateEducation`,
  async (payload: UpdateEducationPayload, { rejectWithValue }) => {
    try {
      await educationApi.updateEducation(payload);
      toast.success(intl.formatMessage({ id: 'education_updated' }));
      return null;
    } catch (e) {
      showServerError(e);
      return rejectWithValue(e);
    }
  },
);

export const asyncCreateEducation = createAsyncThunk(
  `${EDUCATIONS_SLICE_NAME}/createEducation`,
  async (payload: EducationPayload, { rejectWithValue }) => {
    try {
      await educationApi.createEducation(payload);
      toast.success(intl.formatMessage({ id: 'education_created' }));
      return null;
    } catch (e) {
      showServerError(e);
      return rejectWithValue(e);
    }
  },
);

export const asyncDeleteEducation = createAsyncThunk(
  `${EDUCATIONS_SLICE_NAME}/deleteEducation`,
  async (id: number, { rejectWithValue }) => {
    try {
      await educationApi.deleteEducation(id);
      toast.success(intl.formatMessage({ id: 'education_deleted' }));
      return null;
    } catch (e) {
      showServerError(e);
      return rejectWithValue(e);
    }
  },
);

export const unsetEducation = createAction('UNSET_EDUCATION');
